// extracted by mini-css-extract-plugin
module.exports = {"info":"invoice-list_info_lZIkX","actions":"invoice-list_actions_20Hq-","icon":"invoice-list_icon_1e5vA","status":"invoice-list_status_2z29u","email":"invoice-list_email_3FNKx"};